
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/radce/majitel",
      function () {
        return require("private-next-pages/radce/majitel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/radce/majitel"])
      });
    }
  